
import TimeSlotModel from './TimeSlotModel';
import moment from 'moment';

export default class CounselorAvailabilityModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.day = moment(data.day).toDate();
    this.day_of_the_week = data.day_of_the_week || 0;

    this.morning_slots = (data.morning_slots || []).map(d => new TimeSlotModel(d));
    this.afternoon_slots = (data.afternoon_slots || []).map(d => new TimeSlotModel(d));
    this.evening_slots = (data.evening_slots || []).map(d => new TimeSlotModel(d));
  }
}
